// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimTransferInfoDto
 */
export interface IClaimTransferInfoDto {
    /**
     * 
     * @type {number}
     * @memberof IClaimTransferInfoDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimTransferInfoDto
     */
    claim_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimTransferInfoDto
     */
    account_from_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimTransferInfoDto
     */
    account_from_name?: string;
    /**
     * 
     * @type {number}
     * @memberof IClaimTransferInfoDto
     */
    account_to_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimTransferInfoDto
     */
    account_to_name?: string;
    /**
     * 
     * @type {number}
     * @memberof IClaimTransferInfoDto
     */
    posting_id_from?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimTransferInfoDto
     */
    posting_id_to?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimTransferInfoDto
     */
    created_by_contact_id?: number;
    /**
     * 
     * @type {Date}
     * @memberof IClaimTransferInfoDto
     */
    created_at?: Date;
    /**
     * 
     * @type {number}
     * @memberof IClaimTransferInfoDto
     */
    amount?: number;
}

/**
 * Check if a given object implements the IClaimTransferInfoDto interface.
 */
export function instanceOfIClaimTransferInfoDto(value: object): value is IClaimTransferInfoDto {
    return true;
}

export function IClaimTransferInfoDtoFromJSON(json: any): IClaimTransferInfoDto {
    return IClaimTransferInfoDtoFromJSONTyped(json, false);
}

export function IClaimTransferInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimTransferInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'claim_id': json['claim_id'] == null ? undefined : json['claim_id'],
        'account_from_id': json['account_from_id'] == null ? undefined : json['account_from_id'],
        'account_from_name': json['account_from_name'] == null ? undefined : json['account_from_name'],
        'account_to_id': json['account_to_id'] == null ? undefined : json['account_to_id'],
        'account_to_name': json['account_to_name'] == null ? undefined : json['account_to_name'],
        'posting_id_from': json['posting_id_from'] == null ? undefined : json['posting_id_from'],
        'posting_id_to': json['posting_id_to'] == null ? undefined : json['posting_id_to'],
        'created_by_contact_id': json['created_by_contact_id'] == null ? undefined : json['created_by_contact_id'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'amount': json['amount'] == null ? undefined : json['amount'],
    };
}

export function IClaimTransferInfoDtoToJSON(json: any): IClaimTransferInfoDto {
    return IClaimTransferInfoDtoToJSONTyped(json, false);
}

export function IClaimTransferInfoDtoToJSONTyped(value?: IClaimTransferInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'claim_id': value['claim_id'],
        'account_from_id': value['account_from_id'],
        'account_from_name': value['account_from_name'],
        'account_to_id': value['account_to_id'],
        'account_to_name': value['account_to_name'],
        'posting_id_from': value['posting_id_from'],
        'posting_id_to': value['posting_id_to'],
        'created_by_contact_id': value['created_by_contact_id'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'amount': value['amount'],
    };
}

